<imp-modal-header [title]="'APP_V4_COMPANY_MODAL_TITLE'" />
<imp-modal-body>
  <p>{{ 'APP_V4_COMPANY_MODAL_DESCRIPTION' | translate }}</p>
  <imp-label [label]="'APP_V4_COMPANY_MODAL_CONTROL_LABEL'">
    <imp-select-custom
      [formControl]="companySelect"
      [placeholder]="'APP_FORM_SELECT_EMPTY_OPTION' | translate">
      @for (option of options; track option.value) {
        <imp-option [value]="option.value">
          {{ option.label }}
        </imp-option>
      }
    </imp-select-custom>
  </imp-label>
</imp-modal-body>
<imp-modal-footer>
  <imp-button
    label="APP_COMMON_MODAL_BUTTON_CANCEL"
    (action)="close()" />
  <imp-button
    label="APP_COMMON_MODAL_BUTTON_CONFIRM"
    [disabled]="companySelect.pristine"
    variant="primary"
    (action)="linkWithV4()" />
</imp-modal-footer>
